import styled from 'styled-components';

export const CheckboxLabel = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 8px;
`;

export const InfoIcon = styled.span`
  display: inline-flex;
  align-items: center;
  color: var(--link);
`;
